import { useMemo } from 'react';
import { AccountAssetUsdDetail, Asset } from '@mls-wallet/shared-types';
import { useAccountUsdDetails } from './useAccountUsdDetails';

function accountUsdDetailToAsset(asset: AccountAssetUsdDetail): Asset {
  return {
    id: asset.contractTokenId,
    name: asset.name ?? undefined,
    symbol: asset.symbol,
    decimals: asset.decimals,
    logoUrl: asset.logoUrl ?? undefined,
    tokenAddress: asset.address,
    balancesByNetwork: asset.balancesByNetwork,
  };
}

// Account assets now come from the server-composed usd-details route, but this
// hook keeps the old Asset[] shape for the existing UI consumers.
export function useAccountAssets(accountId: string) {
  const { accountUsdDetails, isLoading, error, refresh } =
    useAccountUsdDetails(accountId);

  const assets = useMemo(() => {
    if (!accountUsdDetails) {
      return null;
    }

    return accountUsdDetails.assets
      .map(accountUsdDetailToAsset)
      .sort((a, b) => a.symbol.localeCompare(b.symbol));
  }, [accountUsdDetails]);

  return {
    assets,
    isLoading,
    error,
    refresh,
  };
}
